import React from 'react';
import { Box } from '@mui/material';
import LandingHeader from './sections/LandingHeader';
import LandingHero from './sections/LandingHero';
import LandingFeatures from './sections/LandingFeatures';
import LandingAbout from './sections/LandingAbout';
import LandingStats from './sections/LandingStats';
import LandingFooter from './sections/LandingFooter';

const LandingPage = () => {
  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh', scrollBehavior: 'smooth' }}>
      <LandingHeader />
      <LandingHero />
      <LandingFeatures />
      <LandingStats />
      <LandingAbout />
      <LandingFooter />
    </Box>
  );
};

export default LandingPage;
